import { type InsuranceCorporateIdentity } from "../types";

export function BKKVdnLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M93.6999 228.1C83.7999 226.9 75.2999 221.1 70.5999 212.8C64.6999 226.1 61.3999 240.8 61.3999 256.3C61.3999 290.8 77.4999 322.4 104.4 342.5C90.4999 323.3 82.9999 300.3 82.9999 276.1C83.0999 258.9 86.8999 242.7 93.6999 228.1Z"
        fill="#087DBE"
      />
      <path
        d="M169.2 148.5C146 148.5 124.6 155.9 107 168.3C115.9 171.2 123 178.1 126.2 186.9C145.6 171.5 170.2 162.2 196.9 162.2C208.2 162.2 219.1 163.8 229.7 167C211.9 155 191 148.5 169.2 148.5Z"
        fill="#087DBE"
      />
      <path
        d="M121.5 197.5C121.5 210.9 110.7 221.7 97.3001 221.7C83.9001 221.7 73.1001 210.9 73.1001 197.5C73.1001 184.1 83.9001 173.3 97.3001 173.3C110.7 173.3 121.5 184.2 121.5 197.5Z"
        fill="#087DBE"
      />
      <path
        d="M160.6 334.4C158.6 341.1 153.6 346.6 147.1 349.1C173.1 362.6 204.9 360.1 228.5 342.5C206.1 348.7 181.6 346.1 160.6 334.4Z"
        fill="#898F94"
      />
      <path
        d="M130.3 307C117.2 288.2 111.9 265.4 114.8 243.4C101.3 268 102.4 298 117.2 321.5C119.1 314.9 124 309.6 130.3 307Z"
        fill="#898F94"
      />
      <path
        d="M155.8 328C155.8 337.4 148.2 345 138.8 345C129.4 345 121.8 337.4 121.8 328C121.8 318.6 129.4 311 138.8 311C148.2 311.1 155.8 318.7 155.8 328Z"
        fill="#898F94"
      />
      <path
        d="M166.4 275.2L170.8 295.4C171.5 298.7 171.7 299.5 172.2 302.6H172.4C172.9 299.5 173.1 298.7 173.8 295.4L178.2 275.2H181L173.9 305.2H170.4L163.7 275.2H166.4Z"
        fill="#087DBE"
      />
      <path
        d="M193.8 298.7C193.8 301.6 193.6 302.8 192.8 303.8C191.9 304.9 190.2 305.5 188.3 305.5C184.6 305.5 182.4 303.4 182.4 299.8V290C182.4 286.3 184.6 284.2 188.4 284.2C192.2 284.2 193.9 286 193.9 290V295.8H185V298.3C185 300.7 185.2 301.8 185.8 302.5C186.4 303.1 187.3 303.5 188.3 303.5C189.4 303.5 190.4 303.1 190.8 302.3C191.2 301.6 191.3 300.8 191.3 298.6L193.8 298.7ZM191.3 293.7V290C191.3 287.5 190.1 286.1 188.1 286.1C186 286.1 184.9 287.5 184.9 290V293.7H191.3Z"
        fill="#087DBE"
      />
      <path
        d="M270.4 298.7C270.4 301.6 270.2 302.8 269.4 303.8C268.5 304.9 266.8 305.5 264.9 305.5C261.2 305.5 259 303.4 259 299.8V290C259 286.3 261.2 284.2 265 284.2C268.7 284.2 270.5 286 270.5 290V295.8H261.6V298.3C261.6 300.7 261.8 301.8 262.4 302.5C263 303.1 263.9 303.5 264.9 303.5C266 303.5 267 303.1 267.4 302.3C267.8 301.6 267.9 300.8 267.9 298.6L270.4 298.7ZM267.9 293.7V290C267.9 287.5 266.7 286.1 264.7 286.1C262.6 286.1 261.5 287.5 261.5 290V293.7H267.9Z"
        fill="#087DBE"
      />
      <path
        d="M449.8 298.7C449.8 301.6 449.6 302.8 448.8 303.8C447.9 304.9 446.2 305.5 444.3 305.5C440.6 305.5 438.4 303.4 438.4 299.8V290C438.4 286.3 440.6 284.2 444.4 284.2C448.1 284.2 449.9 286 449.9 290V295.8H441V298.3C441 300.7 441.2 301.8 441.8 302.5C442.4 303.1 443.3 303.5 444.3 303.5C445.4 303.5 446.4 303.1 446.8 302.3C447.2 301.6 447.3 300.8 447.3 298.6L449.8 298.7ZM447.3 293.7V290C447.3 287.5 446.1 286.1 444.1 286.1C442 286.1 440.9 287.5 440.9 290V293.7H447.3Z"
        fill="#087DBE"
      />
      <path
        d="M200 284.5C200.1 285.6 200.1 285.9 200.1 287H200.3C201.7 284.8 202.9 284 204.9 284V286.5C201.8 286.7 200.3 288.2 200.3 291.3V305H197.8V286.4C197.8 285.8 197.7 284.8 197.6 284.4L200 284.5Z"
        fill="#087DBE"
      />
      <path
        d="M207.2 284.5H209.5V280L212 279.1V284.5H214.9V286.4H212C212 286.4 212 286.8 212 287.3V300.7C212 302.8 212.5 303.3 214.3 303.3H215V305C214.3 305.1 214 305.1 213.5 305.1C210.8 305.1 209.6 304.2 209.6 302V286.3H207.3V284.5H207.2Z"
        fill="#087DBE"
      />
      <path
        d="M220.5 284.5C220.6 285.6 220.6 285.9 220.6 287H220.8C222.2 284.8 223.4 284 225.4 284V286.5C222.3 286.7 220.8 288.2 220.8 291.3V305H218.3V286.4C218.3 285.8 218.2 284.8 218.1 284.4L220.5 284.5Z"
        fill="#087DBE"
      />
      <path
        d="M236.9 303.3C235.9 304.7 234.4 305.5 232.5 305.5C229.2 305.5 227.5 303.5 227.5 299.5C227.5 296.4 228.6 294.5 230.7 293.5C232.2 292.8 233.9 292.6 236.8 292.5V289.2C236.8 287.1 235.8 286.1 233.8 286.1C232.5 286.1 231.5 286.6 231 287.4C230.6 288 230.5 288.7 230.4 290.5H228C228.1 286 229.8 284.2 233.9 284.2C236.1 284.2 237.8 285 238.5 286.4C238.9 287.3 239.2 288.2 239.2 289.6V303.4C239.2 304 239.2 304.4 239.4 305.2H236.9C236.9 304.4 236.9 304.2 236.9 303.4V303.3ZM236.9 294.4C236.9 294.4 235.9 294.4 235.4 294.4C233.9 294.5 233 294.6 232.2 295C230.8 295.6 230.1 297 230.1 299.2C230.1 302.5 230.9 303.7 233.1 303.7C235.3 303.7 236.9 302.1 236.9 299.8V294.4Z"
        fill="#087DBE"
      />
      <path
        d="M416.1 303.3C415.1 304.7 413.6 305.5 411.7 305.5C408.4 305.5 406.7 303.5 406.7 299.5C406.7 296.4 407.8 294.5 409.9 293.5C411.4 292.8 413.1 292.6 416 292.5V289.2C416 287.1 415 286.1 413 286.1C411.7 286.1 410.7 286.6 410.2 287.4C409.8 288 409.7 288.7 409.6 290.5H407.2C407.3 286 409 284.2 413.1 284.2C415.3 284.2 417 285 417.7 286.4C418.1 287.3 418.4 288.2 418.4 289.6V303.4C418.4 304 418.4 304.4 418.6 305.2H416.1C416.1 304.4 416.1 304.2 416.1 303.4V303.3ZM416.1 294.4C416.1 294.4 415.1 294.4 414.6 294.4C413.1 294.5 412.2 294.6 411.4 295C410 295.6 409.3 297 409.3 299.2C409.3 302.5 410.1 303.7 412.3 303.7C414.5 303.7 416.1 302.1 416.1 299.8V294.4Z"
        fill="#087DBE"
      />
      <path
        d="M252.6 302.6C251.7 304.5 250.4 305.4 248.5 305.4C245.5 305.4 243.7 303.5 243.7 300.4V284.5H246.2V299.8C246.2 302 247.3 303.4 249.2 303.4C251.3 303.4 252.6 301.9 252.6 299.3V284.6H255.1V305.2H252.6V304.3C252.6 304.1 252.6 304 252.9 302.8L252.6 302.6Z"
        fill="#087DBE"
      />
      <path
        d="M274.4 284.5H276.9V285.4C276.9 285.6 276.9 285.9 276.7 286.6H276.9C277.9 284.9 279.2 284.1 280.9 284.1C283.9 284.1 285.7 286 285.7 289.1V305H283.2V289.7C283.2 287.4 282.1 286.1 280.2 286.1C278 286.1 276.8 287.6 276.8 290.2V304.9H274.3V284.5H274.4Z"
        fill="#087DBE"
      />
      <path
        d="M300.9 275.2H309.1C313.8 275.2 316.3 277.9 316.3 283.1V297.5C316.3 302.8 313.9 305.2 308.7 305.2H300.9V275.2ZM303.7 277.4V303H308.1C309.8 303 311.2 302.6 312.1 301.7C313.1 300.8 313.4 299.5 313.4 296.2V283.8C313.4 280.9 313.1 279.8 312.1 278.8C311.1 277.8 309.8 277.4 307.7 277.4H303.7Z"
        fill="#087DBE"
      />
      <path
        d="M329.7 302.6C328.8 304.5 327.5 305.4 325.6 305.4C322.6 305.4 320.8 303.5 320.8 300.4V284.5H323.3V299.8C323.3 302 324.4 303.4 326.3 303.4C328.4 303.4 329.7 301.9 329.7 299.3V284.6H332.2V305.2H329.7V304.3C329.7 304.1 329.7 304 330 302.8L329.7 302.6Z"
        fill="#087DBE"
      />
      <path
        d="M338.7 284.5C338.8 285.6 338.8 285.9 338.8 287H339C340.4 284.8 341.6 284 343.6 284V286.5C340.5 286.7 339 288.2 339 291.3V305H336.5V286.4C336.5 285.8 336.4 284.8 336.3 284.4L338.7 284.5Z"
        fill="#087DBE"
      />
      <path
        d="M356.8 298.9C356.8 301.1 356.6 302.2 356.1 303.2C355.4 304.7 353.7 305.5 351.5 305.5C348 305.5 346.4 303.8 346.4 299.9V289.6C346.4 286 348.2 284.1 351.6 284.1C353.6 284.1 355.1 284.8 355.8 286.1C356.4 287.1 356.6 288.3 356.6 290.8H354.2V289.2C354.2 287.3 353.2 286.2 351.5 286.2C349.4 286.2 348.7 287.4 348.7 291V299C348.7 302.5 349.3 303.5 351.5 303.5C353.2 303.5 354.3 302.4 354.3 300.7V298.9H356.8Z"
        fill="#087DBE"
      />
      <path
        d="M360.5 275.2H363V280.8C363 283.5 363 284.1 362.8 286.6L363 286.7C364 285 365.3 284.2 367.1 284.2C370.2 284.2 371.9 286.1 371.9 289.2V305.1H369.4V289.8C369.4 287.4 368.3 286.2 366.4 286.2C364.2 286.2 363 287.7 363 290.3V305H360.5V275.2Z"
        fill="#087DBE"
      />
      <path
        d="M387.3 275.2H391.4L397.7 294.8C398.9 298.4 399.1 299.2 400 302.5H400.2C400 299 400 298.1 400 294.4V275.2H402.6V305.2H398.5L392.2 285.5C391.1 281.8 390.8 281.1 389.9 277.8H389.7C389.8 281.3 389.9 282.2 389.9 285.8V305.1H387.3V275.2Z"
        fill="#087DBE"
      />
      <path
        d="M422.9 275.2H425.4V280.8C425.4 283.5 425.4 284.1 425.2 286.6L425.4 286.7C426.4 285 427.7 284.2 429.5 284.2C432.6 284.2 434.3 286.1 434.3 289.2V305.1H431.8V289.8C431.8 287.4 430.7 286.2 428.8 286.2C426.6 286.2 425.4 287.7 425.4 290.3V305H422.9V275.2Z"
        fill="#087DBE"
      />
      <path d="M411.7 275.1H409V278H411.7V275.1Z" fill="#087DBE" />
      <path d="M417.3 275.1H414.6V278H417.3V275.1Z" fill="#087DBE" />
      <path
        d="M184.2 197.5C197.1 197.5 202.3 202.5 202.3 213.3C202.3 221.3 198.9 226.2 192.3 227.7C199.7 228.8 203.2 233.5 203.2 243.3C203.2 255.1 197.6 260.4 185.3 260.4H163.5V197.5H184.2ZM182.2 223.2C185.7 223.2 187.5 222.3 188.8 220.9C190.2 219.3 190.4 217.8 190.4 214.7C190.4 207.6 185.8 207.1 181 207.1H175.7V223.1L182.2 223.2ZM175.7 250.7H180.6C187.3 250.7 191 249.6 191 241.7C191 235.3 188.7 232.9 181.8 232.9H175.7V250.7Z"
        fill="#898F94"
      />
      <path
        d="M222.8 197.5V224L237.2 197.5H250.7L234.3 225.7L250.7 260.4H236.9L222.8 228.6V260.4H210.5V197.5H222.8Z"
        fill="#898F94"
      />
      <path
        d="M269.4 197.5V224L283.8 197.5H297.3L280.9 225.7L297.3 260.4H283.5L269.4 228.6V260.4H257.1V197.5H269.4Z"
        fill="#898F94"
      />
      <path
        d="M322.3 197.5L331.4 243.2L341.7 197.5H353.7L338.3 260.4H324L309.6 197.5H322.3Z"
        fill="#087DBE"
      />
      <path
        d="M377.4 197.5C396.8 197.5 398 210.7 398 229.5C398 248.5 396.1 260.3 376.6 260.3H358.6V197.5H377.4ZM371.1 250.5H374.1C376.9 250.5 379.1 250.3 380.8 249.5C384.6 247.5 385.8 242.2 385.8 229.9C385.8 220.3 385.2 214.7 383.9 211.4C382.4 208 379.5 207.2 374.5 207.2H371.1V250.5Z"
        fill="#087DBE"
      />
      <path
        d="M422.8 197.5L438.5 241.1V197.5H449.8V260.4H433.8L417.7 214.4V260.4H406.4V197.5H422.8Z"
        fill="#087DBE"
      />
      <path
        d="M457.9 204.5C457.9 200.5 461.1 197.3 465.1 197.3C469.1 197.3 472.3 200.5 472.3 204.5C472.3 208.5 469.1 211.7 465.1 211.7C461.2 211.8 457.9 208.5 457.9 204.5ZM471.1 204.5C471.1 201.2 468.4 198.6 465.2 198.6C461.9 198.6 459.2 201.3 459.2 204.5C459.2 207.8 461.9 210.5 465.2 210.5C468.5 210.5 471.1 207.8 471.1 204.5ZM463.7 205V208.7H462.4V200.2H465.1C466.7 200.2 468.3 200.6 468.3 202.5C468.3 203.5 467.7 204.2 466.6 204.5C467.8 204.7 467.9 205.2 468 206.2C468.1 207 468.2 207.9 468.5 208.7H466.8C466.7 208.2 466.6 207.7 466.5 207.2C466.4 206.5 466.4 205.8 466 205.4C465.7 205.1 465.2 205.1 464.8 205.1H463.7V205ZM465.1 203.7C466.3 203.7 466.6 203.1 466.6 202.5C466.6 201.9 466.3 201.5 465.3 201.5H463.7V203.7H465.1Z"
        fill="#087DBE"
      />
    </svg>
  );
}

export const BKKVdn: InsuranceCorporateIdentity = {
  id: "bkk-vdn",
  name: "BKK VDN",
  logo: BKKVdnLogo,
  backgroundColor: "#FFFFFF",
  textColor: "#000000",
  wildcard: "bkk vdn",
  type: "statutory",
};
